import Vue from 'vue'
import { mapValues, forEach, map } from'lodash'


export const namespaced = true


const stateObj = {
	languages: {
		'canadian-french': 'Canadian French',
		'danish': 'Danish',
		'english': 'English',
		'finnish': 'Finnish',
		'french': 'French',
		'german': 'German',
		'italian': 'Italian',
		'norwegian': 'Norwegian',
		'portugese': 'Portuguese',
		'spanish': 'Spanish',
		'swedish': 'Swedish',
		'dutch'  : 'Dutch',
    'romanian': 'Romanian',
    'greek' : 'Greek'
	},
	features: {
		'feature-none': 'None',
		'feature-blackout-wins': 'Blackout Wins',
		'feature-bubble-boost': 'Bubble Boost',
		'feature-collection': 'Collection',
		'feature-diamond-spins': 'Diamond Spins',
		'feature-dualplay': 'dualPLAY',
		'feature-expanding-wilds': 'Expanding Wilds',
		'feature-floating-reels': 'Floating Reels',
		'feature-free-spins-bonus': 'Free Spins Bonus',
		'feature-giant-symbols': 'Giant Symbols',
		'feature-gigantic-wilds': 'Gigantic Wilds',
		'feature-gold-spins-respin': 'Gold Spins Respin',
		'feature-jackpot': 'Jackpot',
		'feature-jackpot-upgrade': 'Jackpot Upgrade',
		'feature-level-up-plus': 'Level Up Plus',
		'feature-lock-and-respin': 'Lock and Respin',
		'feature-megajackpots': 'MegaJackpots',
		'feature-multipliers': 'Multipliers',
		'feature-multiway': 'MultiWay',
		'feature-multiway-xtra': 'MultiWay Xtra',
		'feature-mystery': 'Mystery',
		'feature-powerbucks': 'Powerbucks',
		'feature-prize-disk': 'Prize Disk',
		'feature-progressive': 'Progressive',
		'feature-random-wilds': 'Random Wilds',
		'feature-respin': 'Respin',
		'feature-single-payline': 'Single Payline',
		'feature-split-symbols': 'Split Symbols',
		'feature-stacked-wilds': 'Stacked Wilds',
		'feature-super-stacks': 'Super Stacks',
		'feature-synchronized-reels': 'Synchronized Reels',
		'feature-transforming-wilds': 'Transforming Wilds',
		'feature-tumbling-reels': 'Tumbling Reels',
		'feature-wild-reels': 'Wild Reels',
		'feature-wild-stays-2-plays': 'Wild Stays 2 Plays',
		'feature-wild-stays-charges-then-pays': 'Wild Stays Charges Then Pays',
		'feature-wilds-mania': 'Wilds Mania',
	},
	themes: {
		'theme-none': 'None',
		'theme-adventure': 'Adventure',
		'theme-ancient': 'Ancient',
		'theme-animal': 'Animal',
		'theme-asia': 'Asia',
		'theme-beach': 'Beach',
		'theme-cartoon': 'Cartoon',
		'theme-cat': 'Cat',
		'theme-christmas': 'Christmas',
		'theme-diamonds': 'Diamonds',
		'theme-egm-port': 'EGM Port',
		'theme-egypt': 'Egypt',
		'theme-fairies': 'Fairies',
		'theme-fire': 'Fire',
		'theme-forest': 'Forest',
		'theme-fruit': 'Fruit',
		'theme-game-show': 'Game Show',
		'theme-ghosts': 'Ghosts',
		'theme-halloween': 'Halloween',
		'theme-horse-racing': 'Horse Racing',
		'theme-irish': 'Irish',
		'theme-island': 'Island',
		'theme-leisure': 'Leisure',
		'theme-magic': 'Magic',
		'theme-movies': 'Movies',
		'theme-music': 'Music',
		'theme-mystical': 'Mystical',
		'theme-mythical': 'Mythical',
		'theme-nature': 'Nature',
		'theme-ocean': 'Ocean',
		'theme-outer-space': 'Outer Space',
		'theme-pirates': 'Pirates',
		'theme-poker': 'Poker',
		'theme-royalty': 'Royalty',
		'theme-sports': 'Sports',
		'theme-spring': 'Spring',
		'theme-stepper': 'Stepper',
		'theme-summer': 'Summer',
		'theme-travel': 'Travel',
		'theme-tv-series': 'TV Series',
		'theme-vlt': 'VLT',
		'theme-volcano': 'Volcano',
		'theme-winter': 'Winter',
		'theme-isoftbet': 'iSoftBet'
	},
	regions: [
		{
			title: 'Europe',
			options: [
				{
					label: 'Belgium',
					value: 'europe--belgium'
				},
				{
					label: 'Czech Republic',
					value: 'europe--czech-republic',
				},
				{
					label: 'Denmark',
					value: 'europe--denmark'
				},
				{
					label: 'Finland',
					value: 'europe--finland',
				},
				{
					label: 'Germany',
					value: 'europe--germany',
				},
				{
					label: 'Greece',
					value: 'europe--greece'
				},
				{
					label: 'Italy',
					value: 'europe--italy'
				},
				{
					label: 'Netherlands',
					value: 'europe--netherlands',
				},
				{
					label: 'Norway',
					value: 'europe--norway'
				},
				{
					label: 'Portugal',
					value: 'europe--portugal',
				},
				{
					label: 'Romania',
					value: 'europe--romania'
				},
				{
					label: 'Spain',
					value: 'europe--spain'
				},
				{
					label: 'Sweden',
					value: 'europe--sweden'
				},
				{
					label: 'UK',
					value: 'europe--uk'
				},
                {
					label: 'Switzerland',
					value: 'europe--switzerland'
				}
			]
		},
		{
			title: 'Canada',
			options: [
				{
					label: 'Alberta',
					value: 'canada--alberta'
				},
				{
					label: 'British Columbia',
					value: 'canada--british-columbia'
				},
				{
					label: 'Manitoba',
					value: 'canada--manitoba'
				},
				{
					label: 'New Brunswick',
					value: 'canada--new-brunswick'
				},
				{
					label: 'Newfoundland and Labrador',
					value: 'canada--newfoundland--and-labrador'
				},
				{
					label: 'Nova Scotia',
					value: 'canada--nova-scotia'
				},
				{
					label: 'Ontario OLG',
					value: 'canada--ontario'
				},
				{
					label: 'Ontario',
					value: 'canada--on'
				},
				{
					label: 'Prince Edward Island',
					value: 'canada--price-edward-island'
				},
				{
					label: 'Quebec',
					value: 'canada--quebec'
				},
			]
		},
		{
			title: 'United States',
			options: [
				{
					label: 'Connecticut',
					value: 'us--connecticut'
				},
				{
					label: 'Michigan',
					value: 'us--michigan'
				},
				{
					label: 'New Jersey',
					value: 'us--new-jersey'
				},
				{
					label: 'Pennsylvania',
					value: 'us--pennsylvania'
				},
				{
					label: 'West Virginia',
					value: 'us--west-virginia'
				},
			]
		},
		{
			title: 'LATAM',
			options: [
				{
					label: 'Colombia',
					value: 'latam--colombia'
				},
				{
					label: 'Mexico',
					value: 'latam--mexico'
				},
			]
		},
	],
	hiddenRegions: [
		'canada--ontario',
		'europe--belgium',
		'europe--czech-republic',
		'europe--finland',
		'europe--norway',
		'europe--portugal'
	],
	fallbackDefaultRegionKey: 'europe--uk',
}
export const state = () => stateObj


export const mutations = {
	...mapValues(stateObj, (val, key) => (state, data) => state[key] = data)
}


export const actions = {
}


export const getters = {
	...mapValues(stateObj, (val, key) => (state) => state[key]),
	languageLabels: (state, getters) => (filter) =>
	{
		let labels = [];
		forEach(getters.languages, (label, key) =>
		{
			if(typeof filter == 'undefined' || filter.indexOf(key) !== -1)
			{
				labels.push(label);
			}
		})

		return labels;
	},
	featureLabels: (state, getters) => (filter) =>
	{
		let labels = [];
		forEach(getters.features, (label, key) =>
		{
			if(typeof filter == 'undefined' || filter.indexOf(key) !== -1)
			{
				labels.push(label);
			}
		})

		return labels;
	},
	themeLabels: (state, getters) => (filter) =>
	{
		let labels = [];
		forEach(getters.themes, (label, key) =>
		{
			if(typeof filter == 'undefined' || filter.indexOf(key) !== -1)
			{
				labels.push(label);
			}
		})

		return labels;
	},
	flattenRegions: (state, getters) => (filter) =>
	{
		let flatRegions = {};
		forEach(getters.regions, (regionGroup) =>
		{
			forEach(regionGroup.options, (region) =>
			{
				if(typeof filter == 'undefined' || filter.indexOf(region.value) !== -1)
				{
					flatRegions[region.value] = {
						group: regionGroup.title,
						label: region.label,
						key: region.value,
						value: region.value,
					}
				}
			})
		})

		return flatRegions;
	},
	flatRegions: (state, getters) =>
	{
		return getters.flattenRegions();
	},
	stringifyRegions: (state, getters) => (filter) =>
	{
		return map(getters.flattenRegions(filter), region => region.label).join(', ')
	},
	regionLabel: (state, getters) => (regionKey) =>
	{
		var regions = getters.flattenRegions(regionKey);
		return regions.hasOwnProperty(regionKey) ? regions[regionKey].label : false;
	},
}



// WEBPACK FOOTER //
// ./src/store/app.js